import React, { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Impressum = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-[#f5f5f7] border-b border-[#e5e5e5]">
        <div className="max-w-[800px] mx-auto px-6 py-12">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-sm text-[#4a7c59] hover:underline mb-6 transition-colors"
          >
            <ArrowLeft size={16} />
            Zurück zur Startseite
          </button>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-4xl md:text-5xl font-bold text-[#1d1d1f] tracking-tight"
          >
            Impressum
          </motion.h1>
        </div>
      </div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="max-w-[800px] mx-auto px-6 py-16"
      >
        <div className="prose-custom">
          <Section title="Impressum">
            <P>
              <strong>Brinckmann Arbeitsbühnen GmbH</strong>
              <br />
              Ruhrallee 13
              <br />
              46395 Bocholt
            </P>
            <P>
              Telefon: 02871 - 24 26 6 0
              <br />
              Telefax: 02871 - 24 26 6 99
              <br />
              E-Mail:{" "}
              <a href="mailto:info@brinckmann-arbeitsbuehnen.de" className="text-[#4a7c59] hover:underline">
                info@brinckmann-arbeitsbuehnen.de
              </a>
            </P>
          </Section>

          <Section title="Vertreten durch">
            <P>Nils Terstegge</P>
          </Section>

          <Section title="Registereintrag">
            <P>
              Eingetragen im Handelsregister.
              <br />
              Registergericht: Coesfeld
              <br />
              Registernummer: 17341
            </P>
          </Section>

          <Section title="Umsatzsteuer-ID">
            <P>
              Umsatzsteuer-Identifikationsnummer nach §27a Umsatzsteuergesetz:
              <br />
              DE 317119914
            </P>
          </Section>

          <Section title="Berufshaftpflichtversicherung">
            <P>
              Allianz Versicherung Werner Böing e.K.
              <br />
              Werther Straße 129
              <br />
              46395 Bocholt
              <br />
              Geltungsbereich: Deutschland, Europa
            </P>
          </Section>

          <Section title="Bildrechte">
            <P>
              © Björn Terstegge
              <br />
              © JLG Industries, Inc.
              <br />
              © Merlo S.p.A.
              <br />
              © Shutterstock
            </P>
          </Section>

          {/* Disclaimer */}
          <div className="border-t border-[#e5e5e5] pt-10 mt-10">
            <h2 className="text-2xl font-bold text-[#1d1d1f] tracking-tight mb-8">
              Disclaimer – rechtliche Hinweise
            </h2>

            <Section title="§ 1 Warnhinweis zu Inhalten">
              <P>
                Die kostenlosen und frei zugänglichen Inhalte dieser Webseite wurden mit größtmöglicher Sorgfalt
                erstellt. Der Anbieter dieser Webseite übernimmt jedoch keine Gewähr für die Richtigkeit und
                Aktualität der bereitgestellten kostenlosen und frei zugänglichen journalistischen Ratgeber und
                Nachrichten. Namentlich gekennzeichnete Beiträge geben die Meinung des jeweiligen Autors und
                nicht immer die Meinung des Anbieters wieder. Allein durch den Aufruf der kostenlosen und frei
                zugänglichen Inhalte kommt keinerlei Vertragsverhältnis zwischen dem Nutzer und dem Anbieter
                zustande, insoweit fehlt es am Rechtsbindungswillen des Anbieters.
              </P>
            </Section>

            <Section title="§ 2 Externe Links">
              <P>
                Diese Website enthält Verknüpfungen zu Websites Dritter (&ldquo;externe Links&rdquo;). Diese
                Websites unterliegen der Haftung der jeweiligen Betreiber. Der Anbieter hat bei der erstmaligen
                Verknüpfung der externen Links die fremden Inhalte daraufhin überprüft, ob etwaige
                Rechtsverstöße bestehen. Zu dem Zeitpunkt waren keine Rechtsverstöße ersichtlich. Der Anbieter
                hat keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung und auf die Inhalte der
                verknüpften Seiten. Das Setzen von externen Links bedeutet nicht, dass sich der Anbieter die
                hinter dem Verweis oder Link liegenden Inhalte zu Eigen macht. Eine ständige Kontrolle der
                externen Links ist für den Anbieter ohne konkrete Hinweise auf Rechtsverstöße nicht zumutbar. Bei
                Kenntnis von Rechtsverstößen werden jedoch derartige externe Links unverzüglich gelöscht.
              </P>
            </Section>

            <Section title="§ 3 Urheber- und Leistungsschutzrechte">
              <P>
                Die auf dieser Website veröffentlichten Inhalte unterliegen dem deutschen Urheber- und
                Leistungsschutzrecht. Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene
                Verwertung bedarf der vorherigen schriftlichen Zustimmung des Anbieters oder jeweiligen
                Rechteinhabers. Dies gilt insbesondere für Vervielfältigung, Bearbeitung, Übersetzung,
                Einspeicherung, Verarbeitung bzw. Wiedergabe von Inhalten in Datenbanken oder anderen
                elektronischen Medien und Systemen. Inhalte und Rechte Dritter sind dabei als solche
                gekennzeichnet. Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder kompletter
                Seiten ist nicht gestattet und strafbar. Lediglich die Herstellung von Kopien und Downloads für
                den persönlichen, privaten und nicht kommerziellen Gebrauch ist erlaubt.
              </P>
              <P>Die Darstellung dieser Website in fremden Frames ist nur mit schriftlicher Erlaubnis zulässig.</P>
            </Section>

            <Section title="§ 4 Besondere Nutzungsbedingungen">
              <P>
                Soweit besondere Bedingungen für einzelne Nutzungen dieser Website von den vorgenannten
                Paragraphen abweichen, wird an entsprechender Stelle ausdrücklich darauf hingewiesen. In diesem
                Falle gelten im jeweiligen Einzelfall die besonderen Nutzungsbedingungen.
              </P>
              <P className="text-[#6e6e73] text-xs">
                Quelle:{" "}
                <a
                  href="https://www.juraforum.de/impressum-generator/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#4a7c59] hover:underline"
                >
                  Impressum Muster von JuraForum.de
                </a>
              </P>
            </Section>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-bold text-[#1d1d1f] tracking-tight mb-4">{title}</h2>
    {children}
  </div>
);

const P = ({ children, className = "" }) => (
  <p className={`text-[#424245] text-[15px] leading-relaxed mb-4 ${className}`}>{children}</p>
);

export default Impressum;
